module.exports = __webpack_public_path__ + "img/logo_千标.f54091ca.png";